import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, takeWhile } from 'rxjs/operators';
import { CheckoutService } from '../services/checkout.service';

@Injectable({
  providedIn: 'root'
})
export class CheckoutGuard implements CanActivate {
  constructor(public checkoutService: CheckoutService, private router: Router) {}
 
  canActivate() {
    return this.checkoutService.getSimpleOrderItems().pipe(
      map(orderItems => {
        if (!!orderItems && orderItems.length > 0) {
          return true;
        }
        else {
          return this.router.parseUrl('/buy-ticket');
        }
      })
    );
  }
}